/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f8dc72668470f5b4779bb6e9d47335a8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { SearchNewLogo } from './logo';
export { SearchNewLogoCS } from './logo-cs';
export { SearchNewIcon } from './icon';
